import type { AuthUser } from '@clinic/contracts';

/**
 * The access token lives ONLY in memory (ADR-004, ADR-015). The refresh token is an HttpOnly
 * cookie the page cannot read. On reload the session is restored through /v1/auth/refresh.
 */
export interface Session {
  accessToken: string;
  user: AuthUser;
}

type Listener = () => void;

class SessionStore {
  private session: Session | null = null;
  private readonly listeners = new Set<Listener>();

  get = (): Session | null => this.session;

  set(session: Session | null): void {
    this.session = session;
    for (const listener of this.listeners) listener();
  }

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };
}

export const sessionStore = new SessionStore();
